<template>
    <div>
        <div class="header">
            <div class="title">欢迎加入玖月琴侣</div>
            <div class="tips">为更好的了解您的需求，方便及时有效的沟通，请填写如下表单。</div>
        </div>
        <div class="form">
            <div class="form_name">
                公司（机构）名称
            </div>
            <div>
                <input v-model="form.orgName" type="text" placeholder="请输入您的公司（机构）名称">
            </div>
            <div class="form_name">
                姓名
            </div>
            <div>
                <input v-model="form.name" type="text" placeholder="请输入您的姓名">
            </div>
            <div class="form_name">
                手机
            </div>
            <div>
                <input type="text" v-model="form.phone" placeholder="请输入您的手机号">
            </div>
            <div class="form_name">
                城市
            </div>
            <div>
                <input type="text" v-model="form.city" placeholder="请输入您所在的城市">
            </div>
        </div>
        <div class="submitBtn" @click="submitBtn">
            提交信息
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Toast ,Notify , Dialog} from 'vant';
Vue.use(Toast);
Vue.use(Notify);
Vue.use(Dialog);
export default {
    data(){
        return{
            form:{
                "orgName":"",
                "phone":"",
                "name":"",
                "province":"",
                "city":""
            }
        }
    },
    methods:{
        submitBtn(){
            let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if(this.form.orgName == ''){
                Notify({ type: 'danger', message: '请填写您的公司（机构）名称' });
            }else if(this.form.name == ''){
                Notify({ type: 'danger', message: '请填写您的姓名' });
            }else if(this.form.phone == ''){
                Notify({ type: 'danger', message: '请填写您的手机号' });
            }else if(this.form.city == ''){
                Notify({ type: 'danger', message: '请填写您所在的城市' });
            }else if(!reg_tel.test(this.form.phone)){
                Notify({ type: 'danger', message: '请填写正确的手机号' });
            }else {
                this.$http.post('/organ/addOrganWebsiteApply',{
                    "orgName":this.form.orgName,
                    "phone":this.form.phone,
                    "name":this.form.name,
                    "city":this.form.city
                }).then(res=>{
                    if(res.data.code == 1){
                        Notify({ type: 'danger', message: res.data.msg });
                    }else {
                        Dialog.confirm({
                            message: '提交成功',
                            theme: 'round-button',
                            showCancelButton:false
                        })
                        .then(() => {
                            this.$router.go(-1) 
                        })
                        .catch(() => {
                            // on cancel
                        });
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.header{
    width: 100%;
    height: 138px;
    background: #FA5151;
    .title{
        text-align: center;
        font-size: 22px;
        line-height: 30px;
        color: #FFFFFF;
        font-size: 500;
        padding:24px 0 16px 0 ;
    }
    .tips{
        width: 88%;
        text-align: center;
        font-size: 14px;
        line-height: 22px;
        color: #FFFFFF;
        margin: 0 auto;

    }
}
.form{
    width: 88%;
    margin: 0 auto;
    .form_name{
        font-size: 16px;
        line-height: 24px;
        color: #000000;
        margin:12px 0;
        font: 500;
    }
    input{
        width: 100%;
        height: 56px;padding-left: 16px;
        border: 1px solid rgba(0, 0, 0, 0.12);
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 16px;
    }
}
.submitBtn{
    width: 88%;
    height: 56px;
    background: #FB554E;
    border-radius: 4px;
    text-align: center;
    line-height: 56px;
    font-size: 16px;
    color: #fff;
    margin:0 auto;
    margin-top:24px;
}
</style>



// WEBPACK FOOTER //
// src/components/cooperation.vue